import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon } from 'assets/icons';
import { FormalityService } from 'services';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  area_id: '',
};

class AdminFormalities extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['ID', 'Tipo de derecho', 'Nombre', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    areas: [],
    item: null,
    visible: false,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Trámites Automatizados',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadAreas();
    this.load();
  }

  loadAreas = async () => {
    const res: any = await FormalityService.admin.getAreas({
      withoutLoading: true,
    });
    this.setState({
      areas: res.areas || [],
    });
  };

  load = async (withoutLoading: boolean = false) => {
    const res: any = await FormalityService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
    });
    this.setState({
      data: res.formalities.rows,
      last_page: res.formalities.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar la plantilla?', async () => {
      await FormalityService.admin.delete({
        formality_id: item.id,
      });
      this.load(true);
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='admin-formalities'>
        <Modal
          className='modal-create-formality'
          visible={visible}
          title={`${this.state.item ? 'Editar' : 'Nueva'} Plantilla`}
          onClose={() => this.onClose()}
        >
          <ModalCreate
            areas={this.state.areas}
            item={this.state.item}
            onClose={() => this.onClose()}
          />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Nombre'
                  label='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de derecho'
                  name='area_id'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Trámites Automatizados'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[3]}
          titleRight={
            <>
              {checkPermission(Constants.MODULES.FORMALITIES, 'write') && (
                <div className='container-add-table' onClick={() => this.add()}>
                  <p>Nuevo</p>
                  <button className='btn add-btn-table'>
                    <img src={AddIcon} />
                  </button>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            const itemNumber = (this.state.page - 1) * 30 + index + 1;
            return (
              <tr key={index}>
                <td>{itemNumber}</td>
                <td>{i.area?.name}</td>
                <td>{i.name}</td>
                <td className='text-right'>
                  {i.file != null && (
                    <Tooltip title='Ver'>
                      <a
                        className='link-icon'
                        target='_blank'
                        href={Constants.BASE_STORAGE + i.file}
                      >
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.FORMALITIES, 'write') && (
                    <Tooltip title='Editar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.edit(e, i)}>
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.FORMALITIES, 'delete') && (
                    <Tooltip title='Eliminar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.delete(e, i)}>
                        <img src={TrashIcon} />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminFormalities);
